import { useMemo, useState } from "react";
import { Download, Search } from "lucide-react";
import { Link } from "react-router-dom";
import { fmtDateTime } from "@/lib/format";
import { downloadCsv } from "@/lib/csv";

const fmtDate = (iso) => new Date(iso).toLocaleDateString("pt-BR");
const fmtPhone = (p) => (p?.length >= 10 ? `(${p.slice(0, 2)}) ${p.slice(2, -4)}-${p.slice(-4)}` : p);
const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export const ParticipantsReport = ({ rows, period }) => {
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    const t = norm(q);
    return t ? rows.filter((r) => norm(`${r.name} ${r.whatsapp} ${r.city} ${r.state}`).includes(t)) : rows;
  }, [rows, q]);
  const exportCsv = () => downloadCsv(`participantes_${period}.csv`,
    ["Nome completo", "WhatsApp", "Cidade", "Estado", "Data do cadastro", "Última participação", "Participações no período"],
    list.map((r) => [r.name, fmtPhone(r.whatsapp), r.city, r.state, fmtDate(r.created_at), r.last_participation ? fmtDateTime(r.last_participation) : "", r.participations]));
  return (
    <section className="space-y-4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-muted-foreground">Quem se cadastrou ou participou no período · <strong data-testid="participants-report-count" className="text-zap-ink">{list.length}</strong></p>
        <div className="flex gap-2">
          <label className="relative flex-1 sm:w-64">
            <Search className="pointer-events-none absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
            <input data-testid="participants-report-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nome, WhatsApp, cidade…"
              className="h-9 w-full rounded-md border border-zap-line pl-8 pr-2 text-sm" />
          </label>
          <button data-testid="participants-report-export" onClick={exportCsv} disabled={!list.length}
            className="flex h-9 items-center gap-1.5 rounded-md bg-zap-deep px-3 text-sm font-medium text-white disabled:opacity-50">
            <Download className="h-4 w-4" />Planilha
          </button>
        </div>
      </div>
      {list.length === 0 ? <p className="text-sm text-muted-foreground">Nenhum participante no período.</p> : (
        <div className="overflow-x-auto rounded-md border border-zap-line">
          <table data-testid="participants-report-table" className="w-full min-w-[760px] text-sm">
            <thead className="bg-zap-mist text-left text-xs text-muted-foreground">
              <tr>{["Nome completo", "WhatsApp", "Cidade", "Estado", "Cadastro", "Última participação", "Participações"].map((h) => <th key={h} className={`px-3 py-2 font-medium ${h === "Participações" ? "text-right" : ""}`}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {list.map((r) => (
                <tr key={r.id} data-testid={`participants-report-row-${r.id}`} className="border-t border-zap-line">
                  <td className="px-3 py-2 font-medium"><Link to={`/admin/conversas?p=${r.id}`} className="hover:underline">{r.name}</Link></td>
                  <td className="whitespace-nowrap px-3 py-2 tabular-nums">{fmtPhone(r.whatsapp)}</td>
                  <td className="px-3 py-2">{r.city}</td>
                  <td className="px-3 py-2">{r.state}</td>
                  <td className="whitespace-nowrap px-3 py-2 tabular-nums">{fmtDate(r.created_at)}</td>
                  <td className="whitespace-nowrap px-3 py-2 tabular-nums">{r.last_participation ? fmtDateTime(r.last_participation) : "—"}</td>
                  <td className="px-3 py-2 text-right font-semibold tabular-nums">{r.participations}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
